export const USERINFO = "USERINFO";
export const EDITINFO = "EDITINFO";
export const RESET_INFO = "RESET_INFO";
